import { defineProperty as _defineProperty } from './_virtual/_rollupPluginBabelHelpers.js';
import { PureComponent } from 'react';
import { PM2DisplayProvider } from '@pm2/store';
import { grid, column, contentContainer } from './grid.style.js';
import { jsx } from 'react/jsx-runtime';

/** Renders a grid with multiple columns. */
class GridComponent extends PureComponent {
  /** Before the actual mount - set the grid size so it's ready */
  constructor(props) {
    super(props);
    /** Contains the cached total size of the rendered grid */
    _defineProperty(this, "gridSize", 0);
    this._calculateGridSize();
  }

  /** Render our grid */
  render() {
    const columns = this.props.columns;
    return /*#__PURE__*/jsx(PM2DisplayProvider, {
      inGrid: true,
      children: /*#__PURE__*/jsx("div", {
        className: grid,
        children: columns.map((column$1, index) => {
          return /*#__PURE__*/jsx("section", {
            className: column,
            style: {
              width: column$1.size / this.gridSize * 100 + "%"
            },
            children: /*#__PURE__*/jsx("div", {
              className: contentContainer,
              children: column$1.children
            })
          }, index);
        })
      })
    });
  }

  /** Helper that calculates the size of the entire grid */
  _calculateGridSize() {
    this.gridSize = 0;

    // Loop over columns & append their size to the total size collection
    this.props.columns.forEach(column => {
      this.gridSize += column.size;
    });
  }
}

export { GridComponent };
//# sourceMappingURL=grid.js.map
